import { FC, lazy } from 'react';
import { Successful } from 'src/hooks/use-axios';
import { OrganisationServiceRequest } from 'src/pages/settings/organisation/use-organisation-service';

const Page = lazy(
  () => import('src/pages/settings/organisation/users/invite/page')
);

type Props = {
  organisationService: Successful<OrganisationServiceRequest>;
};

export const InviteUser: FC<Props> = ({ organisationService }) => {
  return <Page organisationService={organisationService} />;
};
